import React from "react";
import "./FeatureCard.css";

export function FeatureCard({ title, text, icon }: { title: string; text: string; icon: string }) {
  return (
    <div className="featureCard">
      <div className="featureIcon" aria-hidden="true">
        {icon}
      </div>
      <div className="featureTitle">{title}</div>
      <div className="featureText">{text}</div>
    </div>
  );
}